var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinksButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 41,
    viewBox: "0 0 113 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_98_3239)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 113,
    height: 41,
    rx: 8,
    fill: "#CAE9FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.2346 23.446H54.4546V25H49.2746V15.228H51.2346V23.446ZM56.6944 16.32C56.349 16.32 56.0597 16.2127 55.8264 15.998C55.6024 15.774 55.4904 15.4987 55.4904 15.172C55.4904 14.8453 55.6024 14.5747 55.8264 14.36C56.0597 14.136 56.349 14.024 56.6944 14.024C57.0397 14.024 57.3244 14.136 57.5484 14.36C57.7817 14.5747 57.8984 14.8453 57.8984 15.172C57.8984 15.4987 57.7817 15.774 57.5484 15.998C57.3244 16.2127 57.0397 16.32 56.6944 16.32ZM57.6604 17.244V25H55.7004V17.244H57.6604ZM63.8949 17.132C64.8189 17.132 65.5655 17.426 66.1349 18.014C66.7042 18.5927 66.9889 19.4047 66.9889 20.45V25H65.0289V20.716C65.0289 20.1 64.8749 19.6287 64.5669 19.302C64.2589 18.966 63.8389 18.798 63.3069 18.798C62.7655 18.798 62.3362 18.966 62.0189 19.302C61.7109 19.6287 61.5569 20.1 61.5569 20.716V25H59.5969V17.244H61.5569V18.21C61.8182 17.874 62.1495 17.6127 62.5509 17.426C62.9615 17.23 63.4095 17.132 63.8949 17.132ZM73.4447 25L70.8127 21.696V25H68.8527V14.64H70.8127V20.534L73.4167 17.244H75.9647L72.5487 21.136L75.9927 25H73.4447ZM79.9965 25.126C79.3618 25.126 78.7925 25.014 78.2885 24.79C77.7845 24.5567 77.3832 24.244 77.0845 23.852C76.7952 23.46 76.6365 23.026 76.6085 22.55H78.5825C78.6198 22.8487 78.7645 23.096 79.0165 23.292C79.2778 23.488 79.5998 23.586 79.9825 23.586C80.3558 23.586 80.6452 23.5113 80.8505 23.362C81.0652 23.2127 81.1725 23.0213 81.1725 22.788C81.1725 22.536 81.0418 22.3493 80.7805 22.228C80.5285 22.0973 80.1225 21.9573 79.5625 21.808C78.9838 21.668 78.5078 21.5233 78.1345 21.374C77.7705 21.2247 77.4532 20.996 77.1825 20.688C76.9212 20.38 76.7905 19.9647 76.7905 19.442C76.7905 19.0127 76.9118 18.6207 77.1545 18.266C77.4065 17.9113 77.7612 17.6313 78.2185 17.426C78.6852 17.2207 79.2312 17.118 79.8565 17.118C80.7805 17.118 81.5178 17.3513 82.0685 17.818C82.6192 18.2753 82.9225 18.896 82.9785 19.68H81.1025C81.0745 19.372 80.9438 19.1293 80.7105 18.952C80.4865 18.7653 80.1832 18.672 79.8005 18.672C79.4458 18.672 79.1705 18.7373 78.9745 18.868C78.7878 18.9987 78.6945 19.1807 78.6945 19.414C78.6945 19.6753 78.8252 19.876 79.0865 20.016C79.3478 20.1467 79.7538 20.282 80.3045 20.422C80.8645 20.562 81.3265 20.7067 81.6905 20.856C82.0545 21.0053 82.3672 21.2387 82.6285 21.556C82.8992 21.864 83.0392 22.2747 83.0485 22.788C83.0485 23.236 82.9225 23.6373 82.6705 23.992C82.4278 24.3467 82.0732 24.6267 81.6065 24.832C81.1492 25.028 80.6125 25.126 79.9965 25.126Z",
    fill: "#2A2A2B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0399 20.9602C29.4067 22.327 31.6228 22.327 32.9896 20.9602L36.5252 17.4246C37.892 16.0578 37.892 13.8417 36.5252 12.4749C35.1583 11.108 32.9423 11.108 31.5754 12.4749L29.8077 14.2426",
    stroke: "#2A2A2B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8683 18.1316C29.5015 16.7648 27.2854 16.7648 25.9186 18.1316L22.383 21.6672C21.0162 23.034 21.0162 25.2501 22.383 26.6169C23.7499 27.9838 25.9659 27.9838 27.3328 26.6169L29.1006 24.8492",
    stroke: "#2A2A2B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_98_3239",
    x: 0,
    y: 0,
    width: 113,
    height: 41,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 5,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_98_3239"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_98_3239"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinksButton);
export default __webpack_public_path__ + "static/media/LinksButton.98f43313eeed594b8862bbce9bff9b25.svg";
export { ForwardRef as ReactComponent };